import { createContext } from "@videojs/element/context";
/** @internal */
const tooltipGroupContext = createContext(Symbol("@videojs/tooltip-group"));
//#endregion
export { tooltipGroupContext };

//# sourceMappingURL=context.js.map